import { forNamespace } from 'common/lib/util/i18n';
const l = forNamespace('home card overflow menu title');

export type ItemKey =
  | 'subscribe'
  | 'unsubscribe'
  | 'addDueDate'
  | 'changeDueDate'
  | 'addMembers'
  | 'joinCard'
  | 'leaveCard';

export type ItemKeys = { [key in ItemKey]?: boolean };

export interface CardInfo {
  editable: boolean;
  hasDueDate: boolean;
  hasMeAsMember: boolean;
  cardId: string;
  isSubscribed: boolean;
}

export type Handlers = { [key in ItemKey]: () => void };

export interface OverflowItem {
  key: ItemKey;
  name: string;
  onClick: () => void;
  shouldShow: boolean;
}

// TODO: TMON-1006: Use Gamma's trackUE function
export type TrackUe = (
  category: string,
  verb: string,
  dirObj: string,
  prepObj: string,
  indObj: string,
  method: string,
  context: object,
) => void;

interface Tracking {
  getPrepObj: () => string;
  getIndObj: () => string;
  getMethod: (itemName: string) => string;
  trackUe: TrackUe;
}

const trackSubscribe = (tracking: Tracking, cardId: string) => {
  const { trackUe, getPrepObj, getMethod } = tracking;

  const method = getMethod('subscribe');
  const context = { cardId };
  trackUe('home', 'subscribes', 'card', getPrepObj(), '', method, context);
};

const trackUnsubscribe = (tracking: Tracking, cardId: string) => {
  const { trackUe, getPrepObj, getMethod } = tracking;

  const method = getMethod('unsubscribe');
  const context = { cardId };
  trackUe('home', 'unsubscribes', 'card', getPrepObj(), '', method, context);
};

const trackAddDueDate = (tracking: Tracking, cardId: string) => {
  const { trackUe, getIndObj, getMethod } = tracking;

  const method = getMethod('due date');
  const context = { cardId };
  trackUe('home', 'adds', 'due date', '', getIndObj(), method, context);
};

const trackChangeDueDate = (tracking: Tracking, cardId: string) => {
  const { trackUe, getIndObj, getMethod } = tracking;

  const method = getMethod('due date');
  const context = { cardId };
  trackUe('home', 'changes', 'due date', '', getIndObj(), method, context);
};

const trackAddMembers = (tracking: Tracking, cardId: string) => {
  const { trackUe, getIndObj, getMethod } = tracking;

  const method = getMethod('members');
  const context = { cardId };
  trackUe('home', 'changes', 'members', '', getIndObj(), method, context);
};

const trackJoinCard = (tracking: Tracking, cardId: string) => {
  const { trackUe, getIndObj, getMethod } = tracking;

  const method = getMethod('join card');
  const context = { cardId };
  trackUe('home', 'joins', 'card', '', getIndObj(), method, context);
};

const trackLeaveCard = (tracking: Tracking, cardId: string) => {
  const { trackUe, getIndObj, getMethod } = tracking;

  const method = getMethod('leave card');
  const context = { cardId };
  trackUe('home', 'leaves', 'card', '', getIndObj(), method, context);
};

export const getAllOverflowItems = (
  cardInfo: CardInfo,
  handlers: Handlers,
  tracking: Tracking,
): OverflowItem[] => {
  const {
    isSubscribed,
    hasDueDate,
    editable,
    hasMeAsMember,
    cardId,
  } = cardInfo;

  const items: OverflowItem[] = [
    {
      key: 'subscribe',
      name: l('watch'),
      shouldShow: !isSubscribed,
      onClick: () => {
        trackSubscribe(tracking, cardId);
        handlers.subscribe();
      },
    },
    {
      key: 'unsubscribe',
      name: l('stop watching'),
      shouldShow: isSubscribed,
      onClick: () => {
        trackUnsubscribe(tracking, cardId);
        handlers.unsubscribe();
      },
    },
    {
      key: 'addDueDate',
      name: l('add due date'),
      shouldShow: !hasDueDate && editable,
      onClick: () => {
        trackAddDueDate(tracking, cardId);
        handlers.addDueDate();
      },
    },
    {
      key: 'changeDueDate',
      name: l('change due date'),
      shouldShow: hasDueDate && editable,
      onClick: () => {
        trackChangeDueDate(tracking, cardId);
        handlers.changeDueDate();
      },
    },
    {
      key: 'addMembers',
      name: l('add members to card'),
      shouldShow: editable,
      onClick: () => {
        trackAddMembers(tracking, cardId);
        handlers.addMembers();
      },
    },
    {
      key: 'joinCard',
      name: l('join card'),
      shouldShow: !hasMeAsMember && editable,
      onClick: () => {
        trackJoinCard(tracking, cardId);
        handlers.joinCard();
      },
    },
    {
      key: 'leaveCard',
      name: l('leave card'),
      shouldShow: hasMeAsMember && editable,
      onClick: () => {
        trackLeaveCard(tracking, cardId);
        handlers.leaveCard();
      },
    },
  ];

  return items;
};



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/util/overflow-menu-items.ts